// i18n area 'tasks' — locale hy-AM (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.hy-AM.meta.json.
import type { enUS } from './tasks'

export const hyAM: typeof enUS = {
  macrotasks: {
    title: 'Մակրոառաջադրանքներ',
    subtitle: 'Բաղադրյալ գործողություններ — կարելի է վերսկսել ձախողված քայլից կամ ընդհատել',
    colType: 'Տեսակ',
    colTarget: 'Օբյեկտ',
    colPhase: 'Փուլ',
    colSteps: 'Քայլեր',
    empty: 'Մակրոառաջադրանքներ չկան',
    detail: 'Մանրամասներ',
    failedAt: 'ձախողվել է՝',
    resume: 'Կրկին փորձել ձախողված քայլից',
    abort: 'Ընդհատել ամբողջը',
    cancel: 'Չեղարկել',
    actionError: 'Գործողությունը մերժվել է'
  },
  tasks: {
    title: 'Առաջադրանքներ',
    searchPlaceholder: 'Որոնեք ըստ տեսակի կամ թիրախի',
    type: 'Տեսակ',
    target: 'Թիրախ',
    phaseLabel: 'Փուլ',
    progress: 'Ընթացք',
    started: 'Սկսվել է',
    finished: 'Ավարտվել է',
    node: 'Հանգույց',
    empty: 'Առաջադրանքներ չկան',
    loadError: 'Չհաջողվեց բեռնել առաջադրանքները — TVirt բեքենդը հասանելի՞ է',
    limboHint: "'{node}' հանգույցն անհասանելի է {time}-ից — առաջադրանքը պահում է իր թիրախի write lease-ը, մինչև հանգույցը վերադառնա կամ հաստատվի, որ այն անջատված է",
    nodeAttested: 'Հանգույցի անջատված լինելը հաստատված է',
    phase: {
      queued: 'Հերթում',
      running: 'Կատարվում է',
      succeeded: 'Ավարտված',
      failed: 'Ձախողված',
      cancelled: 'Չեղարկված',
      'failed-at-step': 'Ձախողված մի քայլում',
      aborted: 'Ընդհատված'
    },
    dropdown: {
      tooltip: 'Ընթացիկ առաջադրանքներ',
      title: 'Ընթացիկ առաջադրանքներ',
      empty: 'Ընթացիկ առաջադրանքներ չկան',
      viewAll: 'Տեսնել բոլոր առաջադրանքները'
    },
    detail: {
      open: 'Մանրամասներ',
      scope: 'Ոլորտ',
      message: 'Հաղորդագրություն',
      params: 'Պարամետրեր',
      result: 'Արդյունք',
      errorTitle: 'Սխալ',
      steps: 'Քայլեր',
      failedAt: 'ձախողվել է՝',
      superseded: 'փոխարինված',

      // Ստանդարտ երկխոսություն (ռաունդ #156). երեխայի տեղը ծնողի պլանում,
      // ծնողն ինքը (բացվում է տեղում) և մեղավոր քայլը:
      step: 'Քայլ',
      parent: 'Ծնող առաջադրանք',
      failedStep: 'Ձախողված քայլ',
      log: 'Մատյան',
      logEmpty: 'Մատյանում դեռ գրառումներ չկան',
      close: 'Փակել'
    },
    actions: {
      cancel: 'Չեղարկել',
      resume: 'Կրկին փորձել ձախողված քայլից',
      abort: 'Ընդհատել ամբողջը (կատարված քայլերի ետադարձ)',
      refused: 'Գործողությունը մերժվել է'
    }
  },
  events: {
    loadError: 'Չհաջողվեց բեռնել մատյանը — TVirt-ի բեքենդը հասանելի՞ է:',
    title: 'Իրադարձություններ',
    subtitle: 'Կլաստերի պատմական հիշողությունը՝ կատարված փաստեր, նորագույնից',
    filterSeverity: 'Ծանրություն',
    filterCategory: 'Կատեգորիա',
    filterAll: 'Բոլորը',
    searchLabel: 'Որոնել',
    searchPlaceholder: 'Որոնել ամբողջ մատյանում',
    subjectFilter: '{subject}-ի իրադարձությունները — ցուցադրել բոլորը',
    colAt: 'Երբ',
    colSeverity: 'Ծանրություն',
    colType: 'Տեսակ',
    colSubject: 'Օբյեկտ',
    colActor: 'Ով',
    colNode: 'Node',
    colMessage: 'Հաղորդագրություն',
    empty: 'Իրադարձություններ չկան',
    loadMore: 'Բեռնել ևս',
    actorSystem: 'համակարգ',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Իրադարձության ID',
    taskCollectedHint: 'Task-ը պահվում է ավելի քիչ. հավաքվելուց հետո հղումն այլևս չի պատասխանում',
    severity: {
      info: 'Տեղեկություն',
      warning: 'Զգուշացում',
      error: 'Սխալ',
      critical: 'Կրիտիկական'
    },
    category: {
      lifecycle: 'Կենսացիկլ',
      config: 'Կարգավորում',
      availability: 'Հասանելիություն',
      security: 'Անվտանգություն'
    },
    type: {
      haNetsvcFailedOver: 'Ցանցային ծառայության վթարային փոխարկում',
      haNetsvcNoCandidate: 'Ցանցային ծառայություն առանց թեկնածու հանգույցի',
      haNetsvcReaped: 'Տեղային ինստանսը հնձվել է հանգույցի վերադարձին',
      netsvcFloatipMoved: 'Լողացող IP-ն տեղափոխվել է այլ պահողի',
      netsvcFloatipNoHolder: 'Լողացող IP առանց առողջ թիրախի',
      haAppFailedOver: 'App օրինակի failover',
      haAppNoCandidate: 'App օրինակ առանց թեկնածու հանգույցի',
      haAppStorageLocalSkip: 'App օրինակը չի տեղափոխվել. մշտական տվյալները տեղային են մահացած հանգույցում',
      haAppReaped: 'App օրինակի տեղային պոդը հնձվել է վերադարձի ժամանակ'
    }
  },
  audit: {
    loadError: 'Չհաջողվեց բեռնել աուդիտի մատյանը — TVirt-ի բեքենդը հասանելի՞ է:',
    title: 'Աուդիտ',
    subtitle: 'Ով ինչ է արել, երբ և որ օբյեկտի վրա՝ փորձված գործողություններ, ներառյալ մերժումները',
    filterOutcome: 'Արդյունք',
    filterAll: 'Բոլորը',
    filterSudo: 'Միայն բարձրացված գործողությունները',
    colAt: 'Երբ',
    colActor: 'Ով',
    colAction: 'Գործողություն',
    colTarget: 'Օբյեկտ',
    colOutcome: 'Արդյունք',
    colNode: 'Node',
    empty: 'Գրանցված գործողություններ չկան',
    loadMore: 'Բեռնել ևս',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Ուղի',
    detailProblem: 'Պատճառ',
    detailTask: 'Task',
    detailClientIp: 'Որտեղից',
    detailId: 'Գրառման ID',
    detailSession: 'Սեանս',
    taskHint: 'Ընդունված գործողության արդյունքն ապրում է իրադարձությունների մատյանում՝ նույն task-ի id-ի ներքո',
    outcome: {
      succeeded: 'Հաջողվեց',
      accepted: 'Ընդունվեց',
      denied: 'Արգելվեց',
      rejected: 'Մերժվեց',
      failed: 'Ձախողվեց'
    }
  },
  notifications: {
    loadError: 'Չհաջողվեց բեռնել ծանուցումները — TVirt-ի բեքենդը հասանելի՞ է:',
    actionError: 'Գործողությունը մերժվել է',
    title: 'Ծանուցումներ',
    subtitle: 'Ուղղությունները, որոնց մատյանի փաստերը դուրս են գալիս կլաստերից',
    rulesTitle: 'Կանոններ',
    rulesSubtitle: 'Որ փաստերն են դուրս գալիս և ուր',
    deliveriesTitle: 'Առաքումներ',
    deliveriesSubtitle: 'Յուրաքանչյուր ծանուցման արդյունքը՝ պատճառով, երբ ձախողվում է',
    colName: 'Անուն',
    colKind: 'Տեսակ',
    colWhere: 'Ուր',
    colScope: 'Scope',
    colSeverity: 'Ծանրություն',
    colMatch: 'Զտիչ',
    colTargets: 'Ուղղություն',
    colAt: 'Երբ',
    colState: 'Վիճակ',
    colEvent: 'Դեպք',
    colAttempts: 'Փորձեր',
    colOutcome: 'Արդյունք',
    empty: 'Տողեր չկան',
    matchAll: 'բոլոր փաստերը',
    test: 'Փորձել',
    testOk: 'Փորձնական ծանուցումն առաքվել է {target}-ին',
    testFailed: 'Փորձը դեպի {target} ձախողվեց՝ {reason}',
    retry: 'Վերադարձնել հերթ',
    retried: 'Առաքումը վերադարձվել է հերթ',
    grouped: 'և ևս {count} կրկնություն',
    state: {
      failed: 'Ձախողվեց',
      pending: 'Հերթում է',
      sending: 'Ուղարկվում է',
      sent: 'Ուղարկված է'
    },
    tabTargets: 'Ուղղություններ',
    tabRules: 'Կանոններ',
    tabDeliveries: 'Առաքումներ',
    targetCreateTitle: 'Նոր ուղղություն',
    ruleCreateTitle: 'Նոր կանոն',
    nameHint: 'Փոքրատառեր, թվեր և գծիկներ. եզակի յուրաքանչյուր տիրույթում',
    kindImmutableHint: 'Անփոփոխ. տեսակը փոխելը նշանակում է ստեղծել այլ ուղղություն',
    kindSmtp: 'Փոստ (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Վիճակ',
    enabledOn: 'Ակտիվ',
    enabledOff: 'Կասեցված',
    smtpHost: 'SMTP սերվեր',
    smtpPort: 'Պորտ',
    smtpPortHint: 'Սովորաբար. 25 առանց TLS, 587 starttls-ով, 465 tls-ով',
    smtpSecurity: 'Անվտանգություն',
    smtpFrom: 'Ուղարկող',
    smtpTo: 'Ստացողներ',
    smtpToHint: 'Մեկ կամ մի քանի հասցե՝ ստորակետերով բաժանված',
    webhookUrl: 'URL',
    payload: 'Բովանդակություն',
    payloadHint: 'minimal-ի դեպքում իրադարձության հաղորդագրությունը և տվյալները չեն դուրս գալիս կլաստերից',
    credential: 'Հավատարմագիր',
    credentialNone: 'Ոչ մեկը',
    credentialHintSmtp: 'Relay-ի հաշիվը բանալիների պահոցից. ոչ մեկը նշանակում է անանուն SMTP',
    credentialHintWebhook: 'Ստորագրման գաղտնիքը բանալիների պահոցից. առանց ստորագրության՝ ամեն ոք, ով գիտի URL-ը, կարող է ձևանալ կլաստեր',
    minSeverityHint: 'Շեմ, ոչ բազմություն. այս ծանրությունից վեր',
    categories: 'Կատեգորիաներ',
    categoriesHint: 'Դատարկ = բոլորը',
    types: 'Իրադարձության տեսակներ',
    typesHint: 'Ստորակետերով բաժանված. դատարկ = բոլորը: Անհայտ տեսակը մերժվում է',
    targetsHint: 'Առնվազն մեկը. պետք է լինեն կանոնի տիրույթում կամ նրա նախնիում',
    recursiveOn: 'Նաև ենթատիրույթները',
    recursiveOff: 'Միայն այս տիրույթը',
    recursiveHint: 'Ռեսուրսները ապրում են տերևներում. առանց երեխաների՝ արմատի կանոնը գրեթե ոչինչ չի հաղորդում',
    repeatWindow: 'Խմբավորման պատուհան (վրկ)',
    repeatWindowHint: 'Պատուհանի ընթացքում կրկնությունները փոստ չեն ուղարկում. հաշվվում են առաջինի վրա: 0-ը անջատում է',
    targetInUseError: '{name} ուղղությունը դեռ օգտագործվում է կանոնի կողմից'
  }
}
